import request from './request';
import urlMap from './urlMap';
export async function getReleaseNoteDetail(params) {
    return request.post(urlMap.getReleaseNoteById, params);
}
// 获取更新日志列表
export async function getReleaseNoteList(params) {
    return request.post(urlMap.getReleaseNoteList, params);
}
// 获取帮助中心配置
export async function getConfig(params) {
    return request.post(urlMap.getConfig, params);
}
// 获取基础工单业务类型树
export async function getBizTypeTrees(params) {
    return request.post(urlMap.listBizTypeTrees, {
        langCode: params.language,
        ...params,
    });
}
// 获取基础工单业务类型树
export async function createCase(params) {
    return request.post(urlMap.createCaseCompatibly, params);
}
// 获取详情
export async function getDetail(params) {
    return request.get(urlMap.getDescribe, { params });
}
// 搜索知识点
export async function searchHotKnowledge(params) {
    return request.post(urlMap.searchHotKnowledge, params);
}
/**
 * 获取用户截图权限
 * @returns
 */
export function getSnapshotPermission(param) {
    return request.post('/helppanel/help-panel/getUserPermission', param);
}
/**
 * 更改用户截图权限
 * @returns
 */
export function saveSnapshotPermission(params) {
    return request.post('/helppanel/help-panel/putUserPermission', params);
}
export function uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    return request.post('/file/uploadFile', formData);
}
// 有用 无用
export function userFeedback(params) {
    return request.post('/api/helpPanel/userFeedback/save', params);
}
// 获取动态协议
export function getDynamicFromSchema(params) {
    return request.post('/helppanel/help-panel/case/getBizTypeExtendInfo', params).then(res => {
        // console.log('res', res);
        return res;
    });
}
export function saveLightSurvey(params) {
    return request.post('/api/helpPanel/survey/saveSurveyResult', params).then(res => {
        return res;
    });
}
// 关注和取消关注
export function focusOrCancelHotFeedback(params) {
    return request.post('/api/helpPanel/userFeedback/focusOrCancelHotFeedback', params).then(res => {
        return res;
    });
}
// 获取公司列表
export function getCompanyList(params) {
    return request.post('/api/helpPanel/crm/queryMerchantInfo', params).then(res => {
        return res;
    });
}
